import React from 'react';

import { FieldTimeOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import dayjs from 'dayjs';
import { CircularProgress } from 'components/CircularProgress';
import { useGetArticleOrderMeetQuery } from 'services';

function OrderInterviewHistory({ offerID }) {
  const { Panel } = Collapse;

  const { data: notes, isFetching: isLoading } = useGetArticleOrderMeetQuery(offerID, { skip: !offerID });

  const phoneHistory = notes?.filter((note) => note.type === 1);
  const mailHistory = notes?.filter((note) => note.type === 2);

  if (isLoading) {
    return <CircularProgress />;
  }
  if (phoneHistory?.length || mailHistory?.length !== 0) {
    return (
      <>
        <div className="headerDivWrapper">
          <span>
            <FieldTimeOutlined className="gx-p-1" />
            Görüşme Geçmişi
          </span>
          <div>
            <label className="gx-p-2">
              <MailOutlined className="gx-p-1" />
              {mailHistory?.length}
            </label>

            <label className="gx-p-2">
              <PhoneOutlined className="gx-p-1" />
              {phoneHistory?.length}
            </label>
          </div>
        </div>
        <Collapse
          expandIconPosition="right"
          className="gx-mt-4"
        >
          {notes?.map((note) => (
            <>
              <Panel
                key={note.id}
                icon={false}
                header={
                  <div className="panelHeaderWrapper">
                    <div>
                      <label>{dayjs(note.updatedAt).format('DD/MM/YYYY')}</label>
                      <label>{note.updatedAt.substr(11, 5)}</label>
                    </div>
                    <label className="gx-mt-1">
                      {note.type === 1 ? <PhoneOutlined className="gx-p-1" /> : <MailOutlined className="gx-p-1" />}
                      {note.type === 1 ? 'Telefon Görüşmesi Yapıldı' : 'Mail Atıldı'}
                    </label>
                  </div>
                }
              >
                <div className="gx-p-3">
                  <span className="interviewDetail">{note.type === 1 ? 'Görüşme Detayı' : 'Mail Detayı'}</span>
                  {note.type === 2 && <p dangerouslySetInnerHTML={{ __html: note.content }} />}
                  {note.type === 1 && <p className="gx-mt-1">{note.content}</p>}
                </div>
              </Panel>
            </>
          ))}
        </Collapse>
      </>
    );
  }
  if (!isLoading) {
    return (
      <>
        <h2>Herhangi Bir Görüşme Yapılmamış</h2>
      </>
    );
  }
}

export default OrderInterviewHistory;
